// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__1xOEW","icon":"Input_icon__1vFzZ","input":"Input_input__oBXYO","white":"Input_white__1Ygf3"};